// src/pages/lead-automation/components/SessionHistoryTable.jsx
import React from 'react';
import { CheckCircle, AlertTriangle, XCircle } from 'lucide-react';
import { useLocalization } from '../../../contexts/LocalizationContext';
import styles from './SessionHistoryTable.module.css';

const statusIcon = (status) => {
  if (status === 'success' || status === 'completed') return <CheckCircle size={14} className={styles.iconSuccess} />;
  if (status === 'partial') return <AlertTriangle size={14} className={styles.iconPartial} />;
  return <XCircle size={14} className={styles.iconFailed} />;
};

const SessionHistoryTable = ({ sessions }) => {
  const { t, formatDate } = useLocalization();
  const la = (key) => t(`leadAutomation.session.${key}`);

  if (!sessions || sessions.length === 0) {
    return (
      <div className={styles.empty}>
        <p>{t('leadAutomation.noSessionsYet')}</p>
        <p className={styles.emptyDesc}>{t('leadAutomation.noSessionsYetDescription')}</p>
      </div>
    );
  }

  return (
    <div className={styles.tableWrap}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>{la('date')}</th>
            <th>{la('rowRange')}</th>
            <th>{la('rows')}</th>
            <th className={styles.success}>{la('created')}</th>
            <th className={styles.neutral}>{la('skipped')}</th>
            <th className={styles.warning}>{la('duplicates')}</th>
            <th className={styles.danger}>{la('errors')}</th>
            <th>{la('status')}</th>
            <th>{la('triggeredBy')}</th>
          </tr>
        </thead>
        <tbody>
          {sessions.map((s) => (
            <tr key={s.id}>
              <td>{formatDate ? formatDate(s.createdAt) : s.createdAt}</td>
              <td className={styles.mono}>
                {s.fromRowIndex} – {s.toRowIndex}
              </td>
              <td className={styles.mono}>{s.totalFetched}</td>
              <td className={`${styles.mono} ${styles.success}`}>{s.successCount}</td>
              <td className={`${styles.mono} ${styles.neutral}`}>{s.skippedCount}</td>
              <td className={`${styles.mono} ${styles.warning}`}>{s.duplicateCount}</td>
              <td className={`${styles.mono} ${styles.danger}`}>{s.errorCount}</td>
              <td>
                <span className={`${styles.badge} ${styles[`badge_${s.status}`]}`}>
                  {statusIcon(s.status)}
                  {la(`status${s.status.charAt(0).toUpperCase() + s.status.slice(1)}`)}
                </span>
              </td>
              <td className={styles.userName}>
                {s.triggeredByUser?.name || '—'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SessionHistoryTable;
